import { Suspense, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'core/store';
import { fetchModuleNavigation } from 'core/store/module-navigation';
import { Loading } from 'shared/components/loading';
import { RequireAuth } from 'shared/components/require-auth';
import { navigationProvider } from 'shared/utils/navigation-provider.utils';
import { MainLayout } from '../main-layout';

export const ProtectedLayout = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchModuleNavigation());
    navigationProvider.setNavigate(navigate);
  }, [dispatch, navigate]);

  return (
    <RequireAuth>
      <MainLayout maxWidthEnabled>
        <Suspense fallback={<Loading />}>
          <Outlet />
        </Suspense>
      </MainLayout>
    </RequireAuth>
  );
};
